import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";

import Modal from "../lib/modal";

export default class extends Controller {
  reactRoot = null;

  initialize() {
    this.modal = new Modal();
  }

  connect() {
    document.body.addEventListener("keyup", this.handleKeyPress);
  }

  disconnect() {
    document.body.removeEventListener("keyup", this.handleKeyPress);
  }

  show = () => {
    if (this.reactRoot == null) {
      this.reactRoot = createRoot(this.getReactRootNode());
    }
    this.reactRoot.render(this.getReactComponent());

    this.previousActiveElement = document.activeElement;
    this.modal.show();
  };

  hide = () => {
    this.modal.hide();
    this.reactRoot.unmount();
    this.reactRoot = null;

    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
      this.previousActiveElement = null;
    }
  };

  getReactRootNode() {
    return this.modal.getModalElement().querySelector(".modal-content");
  }

  handleKeyPress = (e) => {
    if (e.key == "Escape" && this.modal.isVisible) {
      this.modal.hide();
    }
  };
}
